import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import permission from "./modules/permission";

Vue.use(Vuex);

let vuexStoreOptions = {
  modules: {
    user,
    permission
  }
};

export default new Vuex.Store(vuexStoreOptions);
